<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.admin.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create bank -->
        <b-modal size="xl" id="create" hide-footer>
          <template v-slot:modal-title>Novo Administrador</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="E-Mail" />
                    <input type="email" v-model="email" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Perfil" />
                    <select v-model="profile_id" class="form-control">
                      <option value="">SELECIONE...</option>
                      <option
                        v-for="profile in profiles"
                        :key="profile.id"
                        :value="profile.id"
                      >
                        {{ profile.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Senha" />
                    <input
                      type="password"
                      v-model="password"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Confirma senha" />
                    <input
                      type="password"
                      v-model="confirm_password"
                      class="form-control"
                      autocomplete="off"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create bank -->
        <v-card>
          <v-card-title>
            Administradores
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="admins"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.status`]="{ item }"
              >{{ item.status == 1 ? "Ativo" : "Inativo" }}
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import { formatDate } from "../functions/format";
import toast from "../components/ToastNotification";
import api from "../services/api";
import routes from "../routes";
import { adminData } from "../lib/functions";

export default {
  name: "Admins",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      profiles: [],
      search: "",
      headers: [
        { text: "Código", value: "id" },
        { text: "Nome", value: "name" },
        { text: "E-mail", value: "email" },
        { text: "Status", value: "status" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      name: "",
      profile_id: "",
      email: "",
      status: "",
      password: "",
      confirm_password: "",
      admins: [],
      loadingCreate: false,
      loading: true,
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable: ({ id }) =>
      routes.push({ name: "admin", params: { id } }),
    async retrieve() {
      await this.getAdmins();
      await this.getProfiles();
    },
    async getAdmins() {
      try {
        this.loading = true;

        const response = await api.get("/admin/paginate");

        const { admins } = response.data;

        this.admins = admins;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getProfiles() {
      const response = await api.get("/admin/profile/all");

      const { profiles } = response.data;

      this.profiles = profiles;
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const {
          name,
          email,
          status,
          profile_id,
          password,
          confirm_password,
        } = this;

        let params = {
          name,
          email,
          status,
          profile_id,
          password,
          confirm_password,
        };

        const response = await api.post("/admin/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.getAdmins();
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("create");
    },
  },
};
</script>